// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as actions from '../store/actions'
import Cart from '../components/cart/index'
import map from 'lodash/map'
import get from 'lodash/get'
import join from 'lodash/join'

const mapStateToProps = (state) => {
  const cartHash = join(map(state.cart.items, (item) => {
    return item.productId
  }), '')

  return {
    items: state.cart.items,
    itemsWithProductInfo: state.cart.itemsWithProductInfo,
    cartHash: cartHash,
    productInfoReceiving: state.cart.getProductInfoFromServerRetrieving,
    productInfoError: state.cart.getProductInfoFromServerError,
    loadMoreProductInfo: cartHash !== get(state.cart.getProductInfoFromServerExtraArgs, 'cartHash'),
    checkoutUrlRetrieving: state.cart.createCheckOutSessionRetrieving,
    checkoutUrl: get(state.cart.createCheckOutSessionResponse, 'url'),
    getStoreSettingsRetrieving: state.cart.getStoreSettingsRetrieving,
    getStoreSettingsResponse: state.cart.getStoreSettingsResponse,
    getStoreSettingsError: state.cart.getStoreSettingsError,
    isTestMode: state.cart.isTestMode,
    insightsTrackingId: state.cart.insightsTrackingId,
    insightsUserId: state.cart.insightsUserId,
    insightsSessionId: state.cart.insightsSessionId,
    checkoutWindow: state.cart.checkoutWindow,
    tracker: get(state.cart.getProductInfoFromServerResponse, 'tracker'),
    pickupInstruction: get(state.cart.getProductInfoFromServerResponse, 'pickup_instruction'),
    pickupAddress: get(state.cart.getProductInfoFromServerResponse, 'pickup_address')
  }
}

const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatch)(Cart)
